'use client'

import Image from 'next/image'
import { useEffect, useRef, useState } from 'react'

type Publication = { name: string; logo: string; href: string }

export default function PressCarousel({ publications, label, previousLabel, nextLabel }: {
  publications: Publication[]; label: string; previousLabel: string; nextLabel: string
}) {
  const track = useRef<HTMLUListElement>(null)
  const [canScroll, setCanScroll] = useState(false)
  useEffect(() => {
    const element = track.current
    if (!element) return
    const update = () => setCanScroll(element.scrollWidth > element.clientWidth + 2)
    const observer = new ResizeObserver(update)
    observer.observe(element)
    update()
    return () => observer.disconnect()
  }, [])
  const move = (direction: number) => {
    const element = track.current
    if (!element) return
    const step = (element.querySelector('li')?.getBoundingClientRect().width ?? 220) + (parseFloat(getComputedStyle(element).columnGap) || 0)
    const atEnd = element.scrollLeft + element.clientWidth >= element.scrollWidth - 2
    const left = direction > 0 && atEnd ? 0 : direction < 0 && element.scrollLeft <= 0 ? element.scrollWidth : element.scrollLeft + direction * step
    element.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })
  }
  return <section className="fp-press-featured fp-editorial-width" aria-label={label} aria-roledescription="carousel">
    <div className="fp-press-featured-heading"><h2>{label}</h2>
      {canScroll && <div className="fp-carousel-controls"><button type="button" onClick={() => move(-1)} aria-label={previousLabel}>←</button><button type="button" onClick={() => move(1)} aria-label={nextLabel}>→</button></div>}
    </div>
    <ul ref={track} className="fp-publication-track">{publications.map(publication => <li key={publication.name}>
      <a href={publication.href} target="_blank" rel="noopener noreferrer"><Image src={publication.logo} alt={publication.name} width={240} height={70} /></a>
    </li>)}</ul>
  </section>
}
